import { IGenericModal, Modal } from 'components/Modal/Modal';
import { Button, TextField } from 'components/_form';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  deletePlatformMethodology,
  editPlatformMethodology,
  getPlatformMethodology
} from 'api/platformMethodologies';
import { showPlatformApiError } from 'views/PlatformView/platformApiError';

interface Props extends IGenericModal {
  methodologyId: number;
  onSubmitSuccess: () => void;
  onDeleteSuccess: () => void;
}

export const EditPlatformMethodologyForm = ({
  isOpen,
  onCancelClick,
  methodologyId,
  onSubmitSuccess,
  onDeleteSuccess
}: Props) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  useEffect(() => {
    if (!isOpen) return;

    getPlatformMethodology(methodologyId)
      .then((response) => setName(response.data.name))
      .catch((error) => showPlatformApiError(error, t));
  }, [isOpen, methodologyId, t]);

  const handleSave = async () => {
    try {
      await editPlatformMethodology(methodologyId, {
        methodology: { name: name.trim() }
      });
      onSubmitSuccess();
    } catch (error) {
      showPlatformApiError(error, t);
    }
  };

  const handleDelete = async () => {
    try {
      await deletePlatformMethodology(methodologyId);
      onDeleteSuccess();
    } catch (error) {
      showPlatformApiError(error, t);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onCancelClick={onCancelClick}
      headerTitle={t('platformResources.editMethodology')}
      mainButton={{
        action: handleSave,
        variant: 'eucalyptus',
        label: t('buttons.save')
      }}
      isSecondButtonVisible
      gridTemplateColumns="70%"
      additionalFooter={
        <Button variant="red" onClick={handleDelete}>
          {t('buttons.delete')}
        </Button>
      }
    >
      <TextField
        label={t('platformResources.fields.name')}
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
    </Modal>
  );
};
